module.exports = __webpack_public_path__ + "static/media/cold1.8c696697.svg";